import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=2c696af2&scoped=true&"
import script from "./registration.vue?vue&type=script&lang=js&"
export * from "./registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c696af2",
  null
  
)

export default component.exports